import isNil from "lodash/fp/isNil";

class Controller {
  constructor($mdDialog, ride, isCorporateRevised, bookingsUsers) {
    "ngInject";

    this.$mdDialog = $mdDialog;
    this.ride = ride;
    this.cityRide = ride.city.value;
    this.isCorporateRevised = isCorporateRevised;
    this.bookingsUsers = bookingsUsers;
  }

  checkIfBackupOrTransferAvailable() {
    if (
      isNil(this.ride.backup) ||
      !this.isCorporateRevised ||
      (!isNil(this.bookingsUsers) && this.bookingsUsers.length > 0)
    ) {
      this.showBackupOrTransferModal();
    } else {
      this.showBookingsModal();
    }
  }
  showBackupOrTransferModal() {
    const confirm = this.$mdDialog
      .confirm()
      .multiple(true)
      .title(
        "Backups or transfers might be available. Do you want to proceed to cancel & refund?"
      )
      .ok("Yes")
      .cancel("No");

    this.$mdDialog.show(confirm).then(
      this.showBookingsModal.bind(this), // Yes
      this.close.bind(this) // No
    );
  }

  showBookingsModal() {
    const confirm = this.$mdDialog
      .confirm()
      .multiple(true)
      .title(
        `You will cancel the ride and refund ${this.ride.bookings.count} bookings`
      )
      .ok("Yes")
      .cancel("No");

    this.$mdDialog.show(confirm).then(
      this.confirm.bind(this), // Yes
      this.close.bind(this) // No
    );
  }

  confirm() {
    const { reason } = this;
    this.$mdDialog.hide({
      reason,
    });
  }

  close() {
    this.$mdDialog.cancel();
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/ride/cancelReasons/cancelReasons.controller.js